import React from 'react'
import * as Sentry from '@sentry/react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    // Log to console for development
    console.error('ErrorBoundary caught:', error, errorInfo)

    // Capture error with Sentry in production
    if (import.meta.env.PROD) {
      Sentry.captureException(error, { contexts: { react: errorInfo } })
    }
  }

  componentDidUpdate(prevProps) {
    // Recover when resetKey changes (route/tab switch)
    if (
      this.state.hasError &&
      prevProps.resetKey !== undefined &&
      this.props.resetKey !== prevProps.resetKey
    ) {
      this.setState({ hasError: false, error: null })
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null })
  }

  render() {
    if (this.state.hasError) {
      // Section-level usage: caller-provided fallback (node or render-prop)
      const { fallback } = this.props
      if (fallback) {
        return typeof fallback === 'function'
          ? fallback(this.state.error, this.handleReset)
          : fallback
      }

      return (
        <div style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#FBF8F1', fontFamily: "'Noto Serif SC', Georgia, serif"
        }}>
          <div style={{ textAlign: 'center', maxWidth: 480, padding: 32 }}>
            <div style={{
              width: 64, height: 64, borderRadius: 16, background: '#fef2f2',
              display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px'
            }}>
              <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="#dc2626" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
              </svg>
            </div>
            <h1 style={{ fontSize: 22, fontWeight: 700, color: '#141414', marginBottom: 8 }}>页面出错了</h1>
            <p style={{ fontSize: 14, color: '#6B655D', marginBottom: 24, lineHeight: 1.6 }}>
              {this.state.error?.message || '应用遇到了意外错误'}
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '10px 32px', borderRadius: 12, border: 'none', cursor: 'pointer',
                background: 'linear-gradient(135deg, #C1751B, #A85E12)', color: '#fff',
                fontSize: 14, fontWeight: 600
              }}
            >
              刷新页面
            </button>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
